import React from 'react';
import { useField } from 'formik';

import Summernote from './Summernote.jsx';

const FieldSummernote = (props) => {
  const [, { value }, { setTouched, setValue }] = useField(props);

  const onChange = (v) => {
    setValue(v.replace(' ', '') === '<br>' ? '' : v);
  };

  return (
    <Summernote
      value={value}
      onBlur={setTouched}
      onChange={onChange}
      {...props}
    />
  );
};

export default FieldSummernote;
